module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "structure-next"
  }, [_c('span', [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "contents.png",
      "src": "OEBPS/image/contents_fmt.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_005#b1"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_007#b2"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 1 // I Got A Useless Degree…Now What?")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_008#b3"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("How to Turn Your Miscellaneous Degree into a Career")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_023#b4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 2 // Finding the Right Career")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_024#b5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("Basics for Finding Your Dream Job")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_028#b6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 3 // Preparing Materials  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_029#b7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("A Crash Course on Cover Letters, Resumes and More")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_042#b8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 4 // Where To Look ")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_043#b9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("Experience that Actually Helps")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_051#b10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 5 // Interviewing 101 ")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_052#b11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("How to Interview Like a Pro")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_055#b12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 6 // Money Talks ")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_056#b13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("Learning how to Negotiate and Leverage Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_059#b14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("CHAPTER 7 // Life After College")])])]), _vm._v(" "), _c('p', {
    staticClass: "headline-colored"
  }, [_c('a', {
    attrs: {
      "id": "a15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_060#b15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("Adjusting to the Real World")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_067#b16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("The Job Seekers Checklist")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_068#b17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Getting To Know Your Skills")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_069#b18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Getting To Know Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_070#b19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Getting To Know Your Dreams")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_071#b20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Assess Yourself: Your Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "a21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_072#b21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("Author Bio")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761e8e70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/NGJobHacks_split_004.vue
// module id = 69
// module chunks = 0